import {extend} from "flarum/common/extend";
import HeaderSecondary from 'flarum/common/components/HeaderSecondary';

/**
 * 头部导航栏
 */
export default function headerNavContent() {
  const { LinkDropdown } = flarum.extensions?.['fof-links']?.['components'];
  extend(LinkDropdown.prototype, 'onupdate', function(vnode) {
    this.$().on('mouseenter', () => {
      this.showing = true;
      m.redraw();
    });

    this.$().on('mouseleave', () => {
      this.showing = false;
      m.redraw();
    });
  });

  extend(HeaderSecondary.prototype, 'items', function (items) {
    if (items.has('flags')) {
      items.remove('flags');
    }

    if (items.has('Drafts')) {
      items.remove('Drafts');
    }
  });
}
